const defaultState = {
    categoryList: [],
    channelList: [],
    selectedRows: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
    categoryid: 0,
    categoryName: "",
    visible: false,
    scrollWidth: 0,
    scrollHeight: 0,
    clientHeight: 0,
    clientWidth: 0,
    status: 0,
    totalCount: 0,
    flag: 0,
    channelModalVisible: false,
    shadeVisible: false,
    selectKey: "",
    title: "Add Category",
    adultControlValue : "",  // 0: on 1:off
}

export default function ClientLinkReducer(state = defaultState, action) {
    switch (action.type) {
        case 'initCategoryList': {
            return initCategoryList(state, action)
        }
        case 'getChannelList': {
            return initChannels(state, action)
        }
        case 'updateCurrenPge': {
            return { ...state, currentPage: action.data.currentPage }
        }
        case 'updatePageSize': {
            return { ...state, pageSize: action.data.pageSize }
        }
        case 'showAddModal': {
            return { ...state, visible: true, title: action.data.modalTitel, flag: action.data.flag }
        }
        case 'hideModal': {
            return { ...state, visible: false }
        }
        case 'updateWidthAndHeight': {
            return { ...state, scrollWidth: action.data.width, scrollHeight: action.data.height, clientHeight: action.data.clientHeight, clientWidth: action.data.clientWidth }
        }
        case 'updateCategoryId': {
            /* return {...state,categoryid:action.data.categoryId,categoryName:action.data.name} */
            return updateCategoryId(state, action)
        }
        case 'updateStatus': {
            return { ...state, status: 1}
        }
        case 'showChannleModal': {
            return { ...state, channelModalVisible: true }
        }
        case 'hideChannleModal': {
            return { ...state, channelModalVisible: false }
        }
        case 'updateSelectedData': {
            return { ...state, selectedRows: action.data.selectedRows }
        }
        case 'clearSelectedRows': {
            return { ...state, selectedRows: [] }
        }
        case 'showLoading': {
            return { ...state, shadeVisible: true }
        }
        case 'hideLoading': {
            return { ...state, shadeVisible: false }
        }
        case 'updataSelectKey': {
            return { ...state, selectKey: action.data.selectKey + "" }
        }
        case 'resetCategoryId': {
            return { ...state, categoryid: 0, selectKey: "" }
        }
        case 'setAdultControl':{
            return {...state, adultControlValue: action.data.adultControlValue}
        }
        default:
            return state
    }
}

const initCategoryList = (state, action) => {
    let selectKey = ""
    if (action.data.selectKey != null && typeof (action.data.selectKey) !== "undefined") {
        selectKey = action.data.selectKey + ""
    }else {
        if (state.selectKey === "") {
            if (action.data.categoryList.length > 0) {
                selectKey = action.data.categoryList[0].id + ""
            }
        } else {
            selectKey = state.selectKey
        }
    }
    return { ...state, categoryList: action.data.categoryList, selectKey: selectKey}
}

const initChannels = (state, action) => {
    let channelList = action.data.channelList;
    let total = action.data.total;
    let totalCount = action.data.totalCount
    // if(!(typeof(action.data.channelList)==="undefined")){
    //     generateSequence(state.pageSize,state.currentPage,channelList);
    // }
    return { ...state, ...{ channelList: channelList, total: total, totalCount: totalCount } }
}

// const generateSequence=(pageSize,page,list)=>{
//     var key = 0;
//     for(let i = 0;i<list.length;i++){
//         key = key + 1;
//         list[i].sequence = key + pageSize * (page -1);
//     }
// }

const updateCategoryId = (state, action) => {
    let name = action.data.name
    if (action.data.name === "default") {
        if (state.categoryList.length > 0) {
            name = state.categoryList[0].name
        }
    }
    return { ...state, categoryid: action.data.categoryId, categoryName: name}
} 


// WEBPACK FOOTER //
// ./src/service/ClientLinkReducer.js